{
	"generic": "Something went wrong. Please try again.",
	"network": "No connection to the server",
	"offline": "You're offline. Some features are unavailable.",
	"unauthorized": "Sign-in required",
	"forbidden": "Access denied",
	"notFound": "Not found",
	"conflict": "Data conflict",
	"validation": "Please check the entered data",
	"tooManyRequests": "Too many requests. Please wait.",
	"serverError": "Server error. We're on it.",
	"ai": {
		"failed": "AI is temporarily unavailable. We'll retry automatically.",
		"timeout": "AI is taking too long to respond",
		"rateLimited": "AI quota exhausted. Try again later.",
		"moderationBlocked": "Request blocked by moderation"
	},
	"upload": {
		"failed": "Upload failed",
		"interrupted": "Upload interrupted",
		"tooSlow": "Connection too slow"
	},
	"sync": {
		"failed": "Sync failed",
		"conflict": "Conflict detected. Please refresh.",
		"retrying": "Retrying sync…"
	},
	"actions": {
		"tryAgain": "Try again",
		"reportBug": "Report a bug",
		"goHome": "Go home"
	},
	"featureTemporarilyDisabled": "This feature is temporarily unavailable — we're already working on it. Please try again a bit later.",
	"moduleUnavailable": {
		"product_disabled": "This section is turned off, so the action is unavailable.",
		"killed": "The section is temporarily unavailable — we're already working on it. Your data is safe.",
		"tier_locked": "This section is available on a higher plan. Upgrade to unlock it.",
		"platform_unsupported": "This section isn't available on this device. Open StudyHub in a browser.",
		"dependency_missing": "This section needs another one that's turned off right now.",
		"external_down": "An external service for this section isn't responding. Please try again later.",
		"lifecycle_removed": "This section has been discontinued. Your existing data stays available."
	},
	"aiDataSharingDenied": "You haven't allowed sending data to AI services, so this AI feature is off. You can turn it on in Settings → Privacy."
}
